<script setup lang="ts">
import { useDrawerStore } from '@/stores/drawer.ts'

const drawerStore = useDrawerStore()
</script>

<template>
  <v-app-bar-nav-icon
    x-small
    height="36"
    width="36"
    color="white"
    class="mx-1 pl-4 no-overlay"
    :ripple="false"
    :icon="drawerStore.drawer.shown ? 'mdi-close' : 'mdi-menu'"
    @click="drawerStore.toggleDrawer"
  ></v-app-bar-nav-icon>
</template>
